import { Component, OnInit } from '@angular/core';
import { Action, select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import {
  selectModalCallback, selectModalConfig,
} from '../../../core/state/selectors/entity-config.selector';
import { confirmErrorAction } from '../../../core/state/actions/entity-config.action';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent implements OnInit {
/* This is creating an observable that is listening to the store. */
  config$ = this.store.pipe(select(selectModalConfig));
  callback$ = this.store.pipe(select(selectModalCallback));
  callbackType: { [key: string]: Action; } | undefined;
  isActive: boolean = false;

  /**
   * A constructor function that takes in a store as a parameter. It then creates a callback$
   * observable that maps the config to the callbackType.
   * @param {Store} store - Store - this is the store that you want to use.
   */
  constructor(private store: Store) {
    this.callback$.pipe(map(config => config)).subscribe((callback) => this.callbackType = callback);
  }

  ngOnInit(): void {
    this.isActive = false;
  }

  /* Dispatching the action based on the typeKey. */
  public callbackClick(typeKey: string) {
    this.isActive =  true;
    try{
      this.store.dispatch(this.callbackType[typeKey]);
    } catch (error) {
      this.store.dispatch(confirmErrorAction({ message: 'An Error occured: ' + error }));
    }
  }
}
